var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBottomGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06319 0.914752C1.28286 0.695083 1.63902 0.695083 1.85869 0.914752L4.83594 3.892L7.81319 0.914752C8.03286 0.695083 8.38902 0.695083 8.60868 0.914752C8.82835 1.13442 8.82835 1.49058 8.60868 1.71025L5.23369 5.08525C5.01402 5.30492 4.65786 5.30492 4.43819 5.08525L1.06319 1.71025C0.84352 1.49058 0.84352 1.13442 1.06319 0.914752Z",
    fill: "#929AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomGray);
export default __webpack_public_path__ + "static/media/arrow-bottom-gray.8eb60e826c89390fc42cdf2da84da091.svg";
export { ForwardRef as ReactComponent };